<template>
  <div class="zv-page">
    <!-- <input class="test" @mouseup="testFn" /> -->
      
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="copyFn">一键配置</el-button>
            <el-button type="primary" @click="doAdd()">新增</el-button>
          </div>
        </zv-table>
      </div>
    </div>
    <el-dialog
      title="一键配置"
      :visible.sync="copyDialog"
      width="30%"
      >
      <span style="font-size: 14px; color: gray">使用默认值初始化：</span>
      <el-select
        v-model="copy_area_id"
        filterable
        clearable
      >
        <el-option
          v-for="item in areaData"
          :key="item.id"
          :label="item.area_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyDialog = false">取 消</el-button>
        <el-button type="primary" @click="disposeFn" v-loading="btn_loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";

export default {
  name: "CountryPatternList",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      btn_loading: false,
      copy_area_id: '',
      areaData: '',
      copyDialog: false,
      table: {
        api: api.areaConfigList,
        query: {

        },
        searchData: [
          {
            type: "select",
            model: "area_id",
            placeholder: "选择所属州",
            api: api.areaList,
            query:{
              area_type: 1,
              page: 1,
              pagesize: vm.$enums.allPageSize
            },
            keyValueName:['id','area_name']
          },
          {
            type: "input",
            model: "q",
            placeholder: "地区名称"
          }
        ],
        columns: [
          {
            title: "地区名称",
            key: "area_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "创建时间",
            key: "add_time",
            minWidth:"120",
            showTooltip: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "最后修改时间",
            key: "update_time",
            minWidth:"120",
            showTooltip: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.update_time));
            }
          },
          {
            title: "开启状态",
            key: "status",
            minWidth:"80",
            render(h, ctx) {
              const statusBtn = h(
                "el-switch",
                {
                  attrs: {
                    value: ctx.row.status,
                    "inactive-value": 0,
                    "active-value": 1,
                    // "inactive-text": "关闭",
                    // "active-text": "开启"
                  },
                  on: {
                    change (status) {
                      vm.doChangeStatus(status, ctx.row.area_id)
                    }
                  }
                }
              );

              return h("span", [statusBtn]);
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "60",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"80",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row.area_id)
                  }
                },
                "编辑"
              );

              let arr = [];
              arr.push(editBtn);
              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
        area_name: '',  // 地区名字
        parent_area_id: '',  // 上级地区ID（顶级是0）
        area_type: ''     // 地区类别 1 洲 2 国 3省 4市
      },
      formRules: {
        area_name: [{
          required: true,
          message: "地区名称不能为空",
          trigger: "blur"
        }],
        parent_area_id: {
          required: true,
          message: "上级地区不能为空",
          trigger: "blur"
        },
        area_type: {
          required: true,
          message: "地区类别不能为空",
          trigger: "blur"
        }
      },
      areaListData: [],   // 全部区域
      areaTypeData: vm.$enums.AreaType.list,   // 区域类型数据
      adddApi: api.addArea
    };
  },

  computed: {
  },

  methods: {
    areaInit() {
      this.$commFunc.getAreaList({ area_type: 2 }).then(res => {
        this.areaData = res;
      });
    },
    async doChangeStatus(status, id) {
      await api.editArea({
        id,
        status: status
      })
      this.$refs.dataTable.refresh()
      this.$message('状态修改成功!')
    },

    doAdd() {
      this.$router.push("/data-analysis/configAreaRisk");
    },

    doEdit(area_id) {
      let routeData = this.$router.resolve("/data-analysis/configAreaRisk?area_id=" + area_id);
      window.open(routeData.href, '_blank');
    },

    // 2020.6.12 新增
    copyFn() {
      this.copyDialog = true
      this.btn_loading = false
    },
    // 2020.6.9 新增一键配置
    async disposeFn() {
      this.btn_loading = true
      let res = await api.configInit({
        area_id: this.copy_area_id
      })
      console.log(res.error_code)
      if(res.error_code == 0 ) {
        this.btn_loading = false
        this.copyDialog = false
        this.$message('配置成功!')
        this.$refs.dataTable.refresh()
      }
    },
    testFn() {
      let text = window.getSelection().toString()
      console.log(text)
    }
  },

  created() {
    this.areaInit()
  },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>

</style>
